export default __webpack_public_path__ + "bee63bca2f54ad058189bf0262cb09fc.png";